import { FC } from 'react';
import { Icon, IconName } from './icons/Icon';
import { useGamenics, GamenicsEvent } from '../hooks/useGamenics';

export type GenesisRole = 'script' | 'illustration' | 'voice';

// 3役対等の役割別エントリー（SYSTEM_SPEC ROLE-01 / GEN-01）。
// 配色メモ: ボタン文字のコントラストAA(4.5:1)確保のため、
// script=Amber地×ink文字 / illustration=violetはprimary(#7c3aed)地×白文字 /
// voice=Teal地×ink文字 を採用（role-illustration #8b5cf6 は白・inkどちらの文字でもAA未達のため）。
const ROLES: { role: GenesisRole; label: string; icon: IconName; cls: string }[] = [
    { role: 'script', label: '書く', icon: 'script', cls: 'bg-role-script text-ink' },
    { role: 'illustration', label: '描く', icon: 'art', cls: 'bg-primary text-white' },
    { role: 'voice', label: '演じる', icon: 'voice', cls: 'bg-role-voice text-ink' },
];

export const RoleEntryButtons: FC<{
    onSelect: (role: GenesisRole) => void;
    className?: string;
}> = ({ onSelect, className = '' }) => {
    const { playSound } = useGamenics();
    return (
        <div className={`flex flex-col sm:flex-row gap-3 justify-center items-center ${className}`}>
            {ROLES.map(({ role, label, icon, cls }) => (
                <button
                    key={role}
                    className={`btn ${cls} min-w-[128px]`}
                    onClick={() => { playSound(GamenicsEvent.TAP_CONFIRM); onSelect(role); }}
                >
                    <Icon name={icon} size={18} /> {label}
                </button>
            ))}
        </div>
    );
};
